import React, { useState } from 'react';
import config from '../../../config';
import { Modal, Button } from 'react-bootstrap';
import UserList from './UserList';

const ProfileComparison = ({ 
  currentUser, 
  selectedUser, 
  activeMeeting, 
  meetingStartTime, 
  profiles, 
  selectedUserId, 
  onUserSelect,
  onDeselectUser,
  isSelectionDisabled 
}) => {
  const isInMeeting = selectedUser && activeMeeting?.user_2 === selectedUser.user_id;
  const [showUserList, setShowUserList] = useState(false);
  
  const handleShowUserList = () => {
    if (isSelectionDisabled) {
      // Optional: Show toast here if you want to indicate why it's disabled
      return;
    }
    setShowUserList(true);
  };

  const handleCloseUserList = () => {
    setShowUserList(false);
  };

  const handleUserSelect = (user) => {
    if (onUserSelect) {
      onUserSelect(user);
    }
    handleCloseUserList();
  };

  return (
    <div className="profile-comparison">
      {/* Status Badge */}
      {isInMeeting && (
        <div className="meeting-status-badge">
          <span className="active-dot"></span>
          In Meeting
        </div>
      )}

      <div className="profiles-container">
        {/* Always show Current User Card */}
        <div className="profile-card-wrapper">
          <div className="profile-card-compact">
            <div className="profile-image-container">
              <img 
                src={`${config.baseURL}/uploads/profiles/${currentUser.profile_image}` || '/images/no-image-found.webp'} 
                alt={`${currentUser.first_name} ${currentUser.last_name}`}
                className="profile-circle"
                onError={(e) => {
                  e.target.src = '/images/no-image-found.webp';
                }}
              />
            </div>
            <div className="profile-details">
              <div className="profile-label">Your Profile</div>
              <h3 className="profile-name">
                {currentUser.first_name} {currentUser.last_name}
              </h3>
              <div className="profile-id">
                {currentUser.profileId || 'N/A'}
              </div>
            </div>
          </div>
        </div>

        {/* VS Separator - Always show */}
        <div className="vs-container">
          <div className="vs-circle">
            <span className="vs-text">VS</span>
          </div>
        </div>

        {/* Selected User Card or Placeholder */}
        <div className="profile-card-wrapper">
          {selectedUser ? (
            <div className={`profile-card-compact position-relative selected-user ${isInMeeting ? 'in-meeting' : ''}`}>
              {/* ✅ Deselect button - only show when no active meeting */}
                  {!isSelectionDisabled && onDeselectUser && (
                    <button 
                      className="deselect-btn"
                      onClick={onDeselectUser}
                      title="Remove friend"
                    >
                      ✕
                    </button>
                  )}
              <div className="profile-image-container">
                <img 
                  src={selectedUser?.profile_image ? `${config.baseURL}/uploads/profiles/${selectedUser.profile_image}`:'/images/no-image-found.webp'} 
                  alt={`${selectedUser.first_name} ${selectedUser.last_name}`}
                  className="profile-circle"
                  onError={(e) => {
                    e.target.src = '/images/no-image-found.webp';
                  }}
                />
              </div>
              <div className="profile-details">
                <div className="profile-header">
                  <div className="profile-label">Selected User</div>
                </div>
                <h3 className="profile-name ">
                  {selectedUser.first_name} {selectedUser.last_name}
                </h3>
                <div className="profile-id">
                  {selectedUser.profileId}
                </div>
              </div>
            </div>
          ) : (
            <div className="profile-card-compact placeholder">
              <div className="profile-image-container">
                <div className="placeholder-circle">
                  <span className="placeholder-icon">👤</span>
                </div>
              </div>
              <div className="profile-details">
                <div className="profile-label">Select a User</div>
                <h3 className="profile-name placeholder-name">
                  No User Selected
                </h3>
                <button 
                  className={`profile-id placeholder-id ${isSelectionDisabled ? 'disabled' : ''}`}
                  type='button'
                  onClick={handleShowUserList}
                  title={isSelectionDisabled ? 'Cannot select while meeting is active' : 'Select friend'}
                  disabled={isSelectionDisabled}
                >
                  +
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Bootstrap Modal for User List */}
      <Modal show={showUserList} onHide={handleCloseUserList} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select a friend</Modal.Title>
        </Modal.Header>
        <Modal.Body className=''>
          {profiles && profiles.length > 0 ? (
            <div className="user-list-modal-content overflow-y-scroll">
              <UserList 
                profiles={profiles}
                selectedUserId={selectedUser?.user_id}
                onUserSelect={handleUserSelect}
                activeMeeting={activeMeeting}
                isSelectionDisabled={isSelectionDisabled}
              />
            </div>
          ) : (
            <div className="text-center p-4">
              <p className="text-muted">No users available to select</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfileComparison;